import { render, staticRenderFns } from "./EtapaEscolar.vue?vue&type=template&id=42fb7d14&"
import script from "./EtapaEscolar.vue?vue&type=script&lang=js&"
export * from "./EtapaEscolar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports